import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowRight, TrendingUp, PieChart, Building2, CheckCircle } from 'lucide-react';
import { services } from '../data/mockData';

const YurtIciSatis = () => {
  const service = services[0];

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <div className="relative h-96 overflow-hidden">
        <img src={service.image} alt={service.title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 to-slate-900/70"></div>
        <div className="absolute inset-0 flex items-center">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl">
              <div className="flex items-center space-x-3 mb-4">
                <div className="bg-orange-500 p-3 rounded-lg">
                  <TrendingUp className="w-8 h-8 text-white" />
                </div>
                <h1 className="text-5xl font-bold text-white">{service.title}</h1>
              </div>
              <p className="text-slate-200 text-xl">{service.description}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Yurt İçi Satış</h2>
            <div className="prose prose-lg max-w-none text-slate-700 space-y-4">
              <p>
                Turkish Menkul Değerler "Kısmi Yetkili Aracı Kurum" olarak yatırımcılarına işlem aracılığı hizmeti sunmaya yetkilidir.
              </p>
              <p>
                İşlem aracılığı faaliyeti; müşterilerin sermaye piyasası araçlarıyla ilgili alım-satım emirlerinin, Borsalar ya da teşkilatlanmış diğer pazar yerlerine iletilmek suretiyle gerçekleştirilmesini ifade eder.
              </p>
            </div>
          </div>

          {/* Sub Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {service.subServices.map((subService) => (
              <Link
                key={subService.link}
                to={subService.link}
                className="group bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-6 border-2 border-slate-200 hover:border-orange-500 transition-all hover:shadow-lg"
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center space-x-2 mb-3">
                      <CheckCircle className="w-5 h-5 text-orange-500" />
                      <h3 className="text-lg font-semibold text-slate-900 group-hover:text-orange-600 transition-colors">
                        {subService.name}
                      </h3>
                    </div>
                  </div>
                  <ArrowRight className="w-5 h-5 text-slate-400 group-hover:text-orange-500 group-hover:translate-x-1 transition-all" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default YurtIciSatis;